import moment from 'moment-timezone';

const formatOffset = (timezone: string): string => {
  const offsetMinutes = moment.tz(timezone).utcOffset();
  if (offsetMinutes === 0) {
    return 'UTC';
  }
  const sign = offsetMinutes > 0 ? '+' : '-';
  const abs = Math.abs(offsetMinutes);
  const hours = String(Math.floor(abs / 60)).padStart(2, '0');
  const minutes = String(abs % 60).padStart(2, '0');
  return `UTC${sign}${hours}:${minutes}`;
};

const buildLabel = (timezone: string, withOffset: boolean): string => {
  const base = timezone.replace(/_/g, ' ');
  if (!withOffset || timezone === 'UTC') {
    return base;
  }
  return `${base} (${formatOffset(timezone)})`;
};

export const getTimezoneOptions = ({ withOffset = false }: { withOffset?: boolean } = {}) => {
  const allowedContinents = [
    'US', 'Europe', 'Africa', 'UTC', 'INDIAN', 'Canada', 'Brazil', 'Australia', 'Atlantic', 'Asia',
  ];

  const zones = moment.tz.names();
  const grouped: Record<string, string[]> = {};

  zones.forEach((zone) => {
    const parts = zone.split('/');
    const continent = parts[0];

    if (!allowedContinents.includes(continent)) {
      return;
    }

    if (!grouped[continent]) {
      grouped[continent] = [];
    }

    grouped[continent].push(zone);
  });

  const timezoneOptions: { label: string; code: string; items: { value: string; label: string }[] }[] = [];

  Object.keys(grouped).forEach((continent) => {
    const continentTimezones = grouped[continent];
    const continentTimezonesOptions = continentTimezones.map((timezone: string) => ({
      value: timezone,
      label: buildLabel(timezone, withOffset),
    }));

    timezoneOptions.push({
      label: continent,
      code: continent,
      items: continentTimezonesOptions,
    });
  });

  // Add UTC and client timezone as suggestions at the top
  const clientTimezone = moment.tz.guess();
  const suggestions = [{ value: 'UTC', label: 'UTC' }];
  if (clientTimezone && clientTimezone !== 'UTC') {
    suggestions.push({ value: clientTimezone, label: buildLabel(clientTimezone, withOffset) });
  }

  timezoneOptions.unshift({
    label: 'Suggestions',
    code: 'Suggestion',
    items: suggestions,
  });

  return timezoneOptions;
};
